import * as debug from '../shared/services/debug.service';
import { Component, OnInit, ViewChild, ViewChildren, QueryList, OnDestroy, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { PerfectScrollbarDirective, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';


import { AppSettings } from '../app.settings';
import { Settings } from '../app.settings.model';
import { rotate, fadeIn } from '../theme/utils/app-animation';
import { appConfig, environment, appUrl } from 'src/environments/environment';
import { Subscription, from, of } from 'rxjs';
import { MenuService } from '../shared/services/menu.service';
import { SecurityService } from '../shared/services/security.service';
import { IUserProfile } from '../shared/responses/iuser-profile';
import { IMenu } from '../shared/responses/imenu';
import { ProfileDbService } from '../shared/services/profile-db.service';
import { delay, defaultHomeMenuId, isMobileWindow, fallbackMenu } from '../shared/utils/utility.common';
import { switchMap, catchError } from 'rxjs/operators';


@Component({
	selector: 'app-pages',
	templateUrl: './pages.component.html',
	styleUrls: ['./pages.component.scss'],
	animations: [rotate, fadeIn],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PagesComponent implements OnInit, OnDestroy, AfterViewInit {

	@ViewChild('sidenav') sidenav: any;
	@ViewChild('backToTop') backToTop: any;
	@ViewChildren(PerfectScrollbarDirective) pss: QueryList<PerfectScrollbarDirective>;
	optionsPsConfig: PerfectScrollbarConfigInterface = {};
	settings: Settings;
	showInfoContent = false;
	toggleSearchBar = false;
	menus = ['vertical', 'horizontal'];
	menuOption: string;
	menuTypes = ['default', 'compact', 'mini'];
	menuTypeOption: string;
	applicationName = appConfig.applicationName;
	isLoggedIn = false;
	appVersion = environment.appVersion;
	sidenavIsOpened = false;
	defaultHomeMenuId = defaultHomeMenuId;
	isBusy = true;
	appUrl = appUrl;

	private subcriptions = new Subscription();

	constructor(public appSettings: AppSettings,
		public router: Router,
		public readonly menuService: MenuService,
		public readonly profileDbService: ProfileDbService,
		public readonly securityService: SecurityService,
		private readonly route: ActivatedRoute,
		private cdr: ChangeDetectorRef
	) {

		this.settings = this.appSettings.settings;

		debug.log('047 PagesComponent instantiated');

		this.menuService.sidenavIsOpenedChanged.subscribe(async isOpen => {

			debug.log(`048 PagesComponent sidenavIsOpenedChanged.subscribe isOpen: ${isOpen}`);

			await this.retry(isOpen);

		});

		this.menuService.isBusyGlobalChanged.subscribe(isBusy => {

			this.isBusy = isBusy;

			this.cdr.detectChanges();

			debug.log(`049 PagesComponent isBusyChanged.subscribe isBusy: ${isBusy} should be equal to this.menuService.isBusy: ${this.menuService.isBusyGlobal}`);

		});
	}

	retry = async (isOpen: boolean) => {

		// if (!SecurityService.isLoggedIn && !this.isVerticalMenu) {
		//     debug.log(`059 PagesComponent sidenavIsOpenedChanged.subscribe isOpen: ${isOpen} User is not logged in. Calling sidenav.open() is not applicable. exiting..`);
		//     this.setSidenavIsPinnedOpened(false);
		//     return;
		// }

		if (!this.isVerticalMenu) {
			debug.log(`059.1 PagesComponent sidenavIsOpenedChanged.subscribe isOpen: ${isOpen} this.isVerticalMenu = false. Calling sidenav.open() is not applicable. exiting..`);
			this.setSidenavIsPinnedOpened(false);
			return;
		}

		let attempts = 0;
		const maxRetry = 2;
		const intervalMiliSeconds = 10;

		while (!this.sidenav && attempts <= maxRetry) {

			await delay(intervalMiliSeconds);

			attempts++;
			debug.log(`059.1 PagesComponent sidenavIsOpenedChanged.subscribe isOpen: ${isOpen} sidenav is not instantiated yet. Retrying in ${intervalMiliSeconds} ms. ${attempts} attempts..`);
		}


		if (!!this.sidenav) {
			if (this.sidenav.opened !== isOpen) {
				if (isOpen) {
					attempts = 0;
					this.sidenav.open();

					debug.log(`060 PagesComponent sidenavIsOpenedChanged.subscribe isOpen: ${isOpen} this.sidenav.opened: ${this.sidenav.opened}`);
					while (!this.sidenav.opened && attempts <= maxRetry) {

						attempts++;
						debug.log(`061 PagesComponent this.sidenav.open() this.sidenav.opened: ${this.sidenav.opened} Retrying sidenav.open() in ${intervalMiliSeconds} ms. ${attempts} attempts..`);

						await delay(intervalMiliSeconds);

						this.sidenav.open();
					}

					this.setSidenavIsPinnedOpened(true);
					if (this.sidenav.opened !== isOpen) {
						debug.warn(`062 PagesComponent sidenavIsOpenedChanged.subscribe this.sidenav.opened: ${this.sidenav.opened} should be ${isOpen}`);
					} else {
						debug.log(`062 PagesComponent sidenavIsOpenedChanged.subscribe this.sidenav.opened: ${this.sidenav.opened} should be ${isOpen}`);
					}

				} else {
					debug.log(`063 PagesComponent sidenavIsOpenedChanged.subscribe isOpen: ${isOpen}`);
					this.sidenav.close();
					this.setSidenavIsPinnedOpened(false);

					debug.log(`064 PagesComponent sidenavIsOpenedChanged.subscribe sidenavIsOpened: ${this.sidenavIsOpened}`);
				}
			} else {
				debug.log(`065 PagesComponent sidenavIsOpenedChanged.subscribe isOpen: ${isOpen}  old value is equal to new value. no action needed.`);
				this.cdr.detectChanges();
			}
		} else {
			debug.log(`066 PagesComponent sidenavIsOpenedChanged.subscribe ${attempts} retries exhausted.`);
		}
	}

	// get isBusy(): boolean {
	//     debug.log(`054 PagesComponent: isBusy: ${this.menuService.isBusy}  this.sidenavIsOpened: ${this.sidenavIsOpened} this.sidenavIsPinned: ${this.settings.sidenavIsPinned}`);
	//     return this.menuService.isBusy;
	// }

	get favoriteMenus(): IMenu[] {
		// debug.log(`054 PagesComponent: favoriteMenus:  this.sidenavIsOpened: ${this.sidenavIsOpened} this.sidenavIsPinned: ${this.settings.sidenavIsPinned}`);
		// debug.log(this.menuService.favoriteMenus);
		return this.menuService.favoriteMenus;
	}

	get parentMenu(): IMenu {
		const activeModule = this.menuService.activeModule;
		// debug.log(`057 PagesComponent: activeModule: ${activeModule}  this.sidenavIsOpened: ${this.sidenavIsOpened} this.sidenavIsPinned: ${this.settings.sidenavIsPinned}`);
		return activeModule;
	}

	get isVerticalMenu(): boolean {
		let isVerticalMenu = this.settings.menu === AppSettings.MenuOrientation.VERTICAL;
		if (isMobileWindow()) {
			isVerticalMenu = true;
		}

		// debug.log(`053 PagesComponent: isVerticalMenu: ${isVerticalMenu}  ${this.settings.menu} === ${AppSettings.MenuOrientation.VERTICAL}  this.sidenavIsOpened: ${this.sidenavIsOpened} this.sidenavIsPinned: ${this.settings.sidenavIsPinned}`);

		return isVerticalMenu;
	}

	ngOnInit() {
		this.optionsPsConfig.wheelPropagation = false;
		debug.log('050 PagesComponent ngOnInit');
		this.route.data
			.subscribe((data: { userProfile: IUserProfile }) => {
				// this.cdr.detectChanges();
				debug.log('051 PagesComponent ngOnInit resolve: Calling this.menuService.initialize userProfile passed by menuResolver:', data.userProfile);
				this.menuService.initialize(data.userProfile, `051.1 PagesComponent.ngOnInit`);
			});
		debug.log('052 PagesComponent ngOnInit');
	}

	ngOnDestroy(): void {
		this.subcriptions.unsubscribe();
	}

	async ngAfterViewInit() {
		this.backToTop.nativeElement.style.display = 'none';
		this.subcriptions.add(this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.scrollToTop();
			}
		}));

		if (isMobileWindow()) {
			this.menuService.expandActiveSubMenu('', 'PagesComponent.closeSubMenus');
		}

		if (!isMobileWindow()) {
			debug.log('072 PagesComponent ngAfterViewInit this.sidenav.open() should be called.');
			if (!!this.sidenav) {

				this.sidenav.open();
				debug.log('073 PagesComponent ngAfterViewInit this.sidenav.open() was called.');
			}
		}

		this.checkProfilePic();
	}

	checkProfilePic() {
		// TODO compare profile timestamp against image timestamp
		const securityServiceIsLoggedIn = this.securityService.isLoggedIn('073.1 PagesComponent ngAfterViewInit');
		from(securityServiceIsLoggedIn)
			.pipe(
				switchMap(isLoggedIn => {
					this.isLoggedIn = isLoggedIn;
					return from(this.profileDbService.getLocalProfile(isLoggedIn, '073.2 PagesComponent ngAfterViewInit'));
				}),
				// switchMap(localDbProfile => {
				//     profile = localDbProfile;
				//     if (isLoggedIn2) {
				//         return from(this.profileDbService.canGetProfilePic());
				//     }

				//     return of(false);
				// }),
				// switchMap(allowApiCall => {
				//     allowApiCall2 = allowApiCall;
				//     if (allowApiCall) {
				//         return this.securityService.getProfilePic(`073.3 PagesComponent ngAfterViewInit`);
				//     }

				//     const image: IUserImage = { image: '', timeStamp: undefined };

				//     return of(image);
				// }),
				// switchMap(userImage => {
				//     if (allowApiCall2 && !!profile) {
				//         profile.profilePic = userImage.image;
				//         profile.profilePicDateUpdated = userImage.timeStamp;
				//         return this.profileDbService.store(true, profile, `073.4 PagesComponent ngAfterViewInit`);
				//     }
				//     return of('');
				// }),
				catchError(ex => {
					return of(undefined);
				})
			)
			.subscribe();
	}

	async toggleSidenav() {
		await this.retry(!this.sidenav.opened);
		debug.log(`081 PagesComponent toggleSidenav isOpen: ${this.sidenav.opened} this.sidenavIsPinned: ${this.settings.sidenavIsPinned}`);
	}

	onOpenedStart(isOpened: boolean) {
		this.setSidenavIsPinnedOpened(true);
		debug.log(`082 PagesComponent onOpenedStart isOpen: ${isOpened} this.sidenavIsOpened: ${this.sidenavIsOpened} this.sidenavIsPinned: ${this.settings.sidenavIsPinned}`);
	}

	private setSidenavIsPinnedOpened(isOpen: boolean) {
		if (isMobileWindow()) {
			this.settings.sidenavIsPinned = false;
		} else {
			this.settings.sidenavIsPinned = isOpen;
			// if (isOpen) {
			//     delay(1000).then(() => {
			//         debug.log(`=========== 090 PagesComponent.setSidenavIsPinnedOpened isOpen: ${isOpen} delaying..`);
			//         this.settings.sidenavIsPinned = isOpen;
			//     });
			//     debug.log(`=========== 090 PagesComponent.setSidenavIsPinnedOpened isOpen: ${isOpen} delaying.. This should come first.`);
			// } else {
			//     debug.log(`=========== 091 PagesComponent.setSidenavIsPinnedOpened isOpen: ${isOpen} delayed. This should come first.`);
			//     this.settings.sidenavIsPinned = isOpen;
			// }
		}
		this.sidenavIsOpened = isOpen;
	}

	onClosedStart() {
		this.setSidenavIsPinnedOpened(false);
		debug.log(`083 PagesComponent onClosedStart sidenavIsOpened: ${this.sidenavIsOpened}`);
	}

	closeInfoContent(showInfoContent: any) {
		this.showInfoContent = !showInfoContent;
	}

	onPsScrollY(event: { target: { scrollTop: number; }; }) {
		(event.target.scrollTop > 300)
			? this.backToTop.nativeElement.style.display = 'flex'
			: this.backToTop.nativeElement.style.display = 'none';

	}

	scrollToTop() {
		this.pss.forEach(ps => {
			if (ps.elementRef.nativeElement.id === 'main') {
				ps.scrollToTop(0, 250);
			}
		});
	}

	closeSubMenus = async () => {
		if (this.sidenav) { await this.retry(false); }
		this.menuService.setActiveModule('/', `PagesComponent.closeSubMenus`);
		if (this.settings.menu === AppSettings.MenuOrientation.VERTICAL) {
			this.menuService.expandActiveSubMenu('', 'PagesComponent.closeSubMenus');
		}
		debug.log(`084 closeSubMenus sidenavIsOpened: ${this.sidenavIsOpened}`);
	}
}
